import { createFileRoute } from '@tanstack/react-router';
import DeveloperDashboard from '@pages/Developer/DeveloperDashboard';

export const Route = createFileRoute('/developer')({
  component: DeveloperDashboard,
});
